
import { defineComponent, PropType } from "vue";
import Spinner from "@/components/Spinner.vue";

export default defineComponent({
  name: "ModelUploader",
  components: { Spinner },
  props: {
    id: {
      type: String,
      default: "",
    },
    label: {
      type: String,
      default: "",
    },
    subLabel: {
      type: String,
      default: "",
    },
    errorMessage: {
      type: String,
      default: "",
    },
    bgImagePath: {
      type: String,
      default: "",
    },
    isLoading: {
      type: Boolean,
      default: false,
    },
    selectedModelName: {
      type: String,
      default: "",
    },
    handleFileChange: {
      type: Function as PropType<(files: FileList) => Promise<unknown>>,
      default: null,
    },
  },
});
